import React, { useEffect, useState, useContext } from "react";
import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { DashboardContext } from "../../../../../contexts/Dashboard/DashboardContext";
import HeaderComponent from "../../../../HeaderComponent";
import LoadingGraphics from "../../../../Loading/LoadingGraphics";
import { Routes } from ".";
import { useParams } from "react-router-dom";

interface Departures {
  interval: number;
  qtd: number;
  delayed: string;
  on_time: string;
  not_started: string;
}

export const ChartBar = ({ data }: Routes) => {
  const { getSizesComponent, setFontSize, componentProperty, generateRedirectUrl } =
    useContext(DashboardContext);
  const [completeRequisition, setCompleteRequisition] = useState(false);
  const [heightChart, setHeightChart] = useState(380);
  const [widthChart, setWidthChart] = useState(300);

  const [notStarted, setNotStarted] = useState<number[]>([]);
  const [onTime, setOnTime] = useState<number[]>([]);
  const [delayed, setDelayed] = useState<number[]>([]);
  const [categories, setCategories] = useState<number[]>([]);
  const [qtd, setQtd] = useState<number[]>([]);
  const [indexTime, setIndexTime] = useState<number>(new Date().getHours());
  const [realTime, setIRealTime] = useState<string>("");
  const [total, setTotal] = useState<number>(0);
  const { mode } = useParams();

  useEffect(() => {
    const time = new Date();
    setIndexTime(time.getHours());
    setIRealTime(time.getHours() + ":" + time.getMinutes());
    setDelayed(
      data.departures.map(function (route: Departures) {
        return parseInt(route.delayed);
      })
    );
    setNotStarted(
      data.departures.map(function (route: Departures) {
        return parseInt(route.not_started);
      })
    );
    setOnTime(
      data.departures.map(function (route: Departures) {
        return parseInt(route.on_time);
      })
    );
    setCategories(
      data.departures.map(function (route: Departures) {
        return route.interval;
      })
    );
    setQtd(
      data.departures.map(function (route: Departures) {
        return route.qtd;
      })
    );
  }, [data]);

  useEffect(() => {
    if (qtd.length !== 0) {
      setTotal(
        qtd.reduce(function (soma: number, i: number) {
          return soma + i;
        })
      );
    }
  }, [qtd]);

  const options: ApexOptions = {
    chart: {
      animations: {
        dynamicAnimation: {
          enabled: true,
          speed: 350,
        },
        enabled: false,
      },
      type: "bar",
      stacked: true,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: true,
      },
      events: {
        dataPointSelection: async (event, chartContext, config) => {
          const selectedInterval = data.departures[config.dataPointIndex].interval;
          const type = config.seriesIndex;
          let status;

          switch (type) {
            case 0:
              status = 'Atrasadas';
              break;
            
            case 1:
              status = 'Em tempo';
              break;

            case 2:
              status = 'Em espera';
              break;
  
            default:
              break;
          }

          if (
            mode === "view" &&
            componentProperty({
              id: "chartDepartures",
              property: "redirect",
            })
          ) {
            window.open(
              await generateRedirectUrl("chartDepartures", {
                redirectTowerToAnalytics: true,
                date: true,
                departureGoalRoute: status,
                routeBeginGoal: selectedInterval
              }),
              "_blank"
            );
          }
        },
      },
    },
    colors: ["#fd6763", "#01b8aa", "#B1BCBE"],
    responsive: [
      {
        breakpoint: 480,
      },
    ],
    dataLabels: {
      enabled: false,
    },
    plotOptions: {
      bar: {
        barHeight: "100%",
        horizontal: false,
      },
    },
    xaxis: {
      categories: categories,
      // position: 'top',
      labels: {
        rotate: -90,
      },
    },
    yaxis: {
      max: Math.max(...qtd),
      show: true,
    },
    grid: {
      xaxis: {
        lines: {
          show: false,
        },
      },
      yaxis: {
        lines: {
          show: false,
        },
      },
    },
    legend: { show: false },
    fill: {
      opacity: 1,
    },
    annotations: {
      xaxis: [
        {
          x: categories[indexTime],
          borderColor: "#FFA510",
          label: {
            borderColor: "#FFA510",
            style: {
              fontSize: "12px",
              color: "#fff",
              background: "#FFA510",
              fontWeight: "bold",
            },
            orientation: "vertical",
            offsetY: 7,
            text: realTime,
          },
        },
      ],
    },
    // annotations: {
    //   xaxis: [
    //     {
    //       x: '14h-15h',
    //       borderColor: '#00E396',
    //       label: {
    //         borderColor: '#00E396',
    //         orientation: 'horizontal',
    //         text: 'X Annotation'
    //       }
    //     }
    //   ]
    // }
  };

  const series = [
    {
      name: "Atrasado",
      data: delayed,
    },
    {
      name: "No horário",
      data: onTime,
    },
    {
      name: "Em espera",
      data: notStarted,
    },
  ];

  useEffect(() => {
    const sizes = getSizesComponent({ id: "chart-departures" });
    if (sizes.width < 345) {
      setFontSize({ id: "chart-departures", width: sizes.width });
    }
    setHeightChart(sizes.height - 40);
    setWidthChart(sizes.width);
    setCompleteRequisition(true);
  }, []);

  return completeRequisition ? (
    <div className="h100">
      <HeaderComponent
        title={`Saídas: ${total} saídas previstas para hoje`}
        clickable={componentProperty({
          id: "chartDepartures",
          property: "redirect",
        })}
        id="chart-departures"
      />
      <div id="chart">
        <Chart
          type="bar"
          options={options}
          series={series}
          height={heightChart}
          width={widthChart}
        />
      </div>
    </div>
  ) : (
    <LoadingGraphics/>
  );
};
